/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TonteDto } from '../models/tonte-dto';


/**
 * Fonctions de gestion des tontes
 */
@Injectable({
  providedIn: 'root',
})
export class TontesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation tonteGetList
   */
  static readonly TonteGetListPath = '/api/tontes/list';

  /**
   * Renvoie la liste des tontes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tonteGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  tonteGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TonteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TontesService.TonteGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TonteDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des tontes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tonteGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tonteGetList(params?: {
  }): Observable<Array<TonteDto>> {

    return this.tonteGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TonteDto>>) => r.body as Array<TonteDto>)
    );
  }

  /**
   * Path part for operation tonteLoadList
   */
  static readonly TonteLoadListPath = '/api/tontes/load-list';

  /**
   * Renvoie la liste des tontes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tonteLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tonteLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TontesService.TonteLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des tontes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tonteLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tonteLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.tonteLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation tonteGet
   */
  static readonly TonteGetPath = '/api/tontes/{id}';

  /**
   * Renvoie la tonte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tonteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tonteGet$Response(params: {

    /**
     * Identifiant de la tonte
     */
    id: number;
  }): Observable<StrictHttpResponse<TonteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TontesService.TonteGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TonteDto>;
      })
    );
  }

  /**
   * Renvoie la tonte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tonteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tonteGet(params: {

    /**
     * Identifiant de la tonte
     */
    id: number;
  }): Observable<TonteDto> {

    return this.tonteGet$Response(params).pipe(
      map((r: StrictHttpResponse<TonteDto>) => r.body as TonteDto)
    );
  }

  /**
   * Path part for operation tontePut
   */
  static readonly TontePutPath = '/api/tontes/{id}';

  /**
   * Met à jour la tonte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tontePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tontePut$Response(params: {

    /**
     * Identifiant de la tonte à mettre à jour
     */
    id: number;

    /**
     * Tonte
     */
    body: TonteDto
  }): Observable<StrictHttpResponse<TonteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TontesService.TontePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TonteDto>;
      })
    );
  }

  /**
   * Met à jour la tonte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tontePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tontePut(params: {

    /**
     * Identifiant de la tonte à mettre à jour
     */
    id: number;

    /**
     * Tonte
     */
    body: TonteDto
  }): Observable<TonteDto> {

    return this.tontePut$Response(params).pipe(
      map((r: StrictHttpResponse<TonteDto>) => r.body as TonteDto)
    );
  }

  /**
   * Path part for operation tonteDelete
   */
  static readonly TonteDeletePath = '/api/tontes/{id}';

  /**
   * Supprime la tonte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tonteDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  tonteDelete$Response(params: {

    /**
     * Identifiant de la tonte à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TontesService.TonteDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la tonte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tonteDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tonteDelete(params: {

    /**
     * Identifiant de la tonte à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.tonteDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation tontePost
   */
  static readonly TontePostPath = '/api/tontes';

  /**
   * Crée la tonte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tontePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tontePost$Response(params: {

    /**
     * Tonte
     */
    body: TonteDto
  }): Observable<StrictHttpResponse<TonteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TontesService.TontePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TonteDto>;
      })
    );
  }

  /**
   * Crée la tonte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tontePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tontePost(params: {

    /**
     * Tonte
     */
    body: TonteDto
  }): Observable<TonteDto> {

    return this.tontePost$Response(params).pipe(
      map((r: StrictHttpResponse<TonteDto>) => r.body as TonteDto)
    );
  }

}
